import Vue from 'vue';
import { noop } from 'lodash';

Vue.directive('off-click', {
    bind (el, binding, vnode) {
        el.handleOutsideClick = (e) => {
            e.stopPropagation();

            var { handler, args, exclude } = binding.value;
            var clickedOnExcludedEl = false;

            exclude.forEach(refName => {
                if (!clickedOnExcludedEl) {
                    var excludedEl = vnode.context.$refs[refName];

                    if (excludedEl.$el) {
                        clickedOnExcludedEl = excludedEl.$el.contains(e.target);
                    }
                    else if (Array.isArray(excludedEl) && excludedEl.length > 0) {
                        if (excludedEl[0].$el) {
                            clickedOnExcludedEl = excludedEl[0].$el.contains(e.target);
                        } else {
                            clickedOnExcludedEl = excludedEl[0].contains(e.target);
                        }
                    }
                    else {
                        clickedOnExcludedEl = excludedEl.contains(e.target);
                    }
                }
            });

            if (!el.contains(e.target) && !clickedOnExcludedEl) {
                if (args) {
                    vnode.context[handler](...args);
                } else {
                    vnode.context[handler]();
                }
            }
        }

        document.addEventListener('click', el.handleOutsideClick);
        document.addEventListener('touchstart', el.handleOutsideClick);
    },

    unbind (el) {
        document.removeEventListener('click', el.handleOutsideClick);
        document.removeEventListener('touchstart', el.handleOutsideClick);
    }
});

Vue.directive('click-out', {
    bind: function (el, binding, vnode) {
      el.clickOutsideEvent = function (event) {
        if (!(el == event.target || el.contains(event.target))) {
          vnode.context[binding.expression](event);
        }
      };
      document.body.addEventListener('click', el.clickOutsideEvent)
    },
    unbind: function (el) {
      document.body.removeEventListener('click', el.clickOutsideEvent)
    },
  });

// Drag And Drop Directive


/**
 * Turns an element draggable by using JQuery UI.
 * Also, has a workaorund for the jquery ui bug due connect a sortable + draggable.
 * @see https://api.jqueryui.com/draggable/
 * @see https://stackoverflow.com/a/33844608
 */
Vue.directive('drag', {
    inserted: function (element, binding, vnode) {

        let offsetStart = {};

        const { handlers = {} } = binding.value;

        const fixedStart = (event, ui) => {
            offsetStart = {
                x: ui.position.left - event.pageX,
                y: ui.position.top - event.pageY,
            };
        };

        const handleFixedStart = (event, ui) => {
            fixedStart(event, ui);
            vnode.context[handlers.start](event, ui);
        };

        const fixedDrag = (event, ui) => {
            if (!ui.helper.parent().is('body')) {
                ui.helper.appendTo($('body'));
            }
            ui.position.top = event.pageY + offsetStart.y;
            ui.position.left = event.pageX + offsetStart.x;
        };

        const handleFixedDrag = (event, ui) => {
            fixedDrag(event, ui);
            vnode.context[handlers.drag](event, ui);
        };

        $(element).draggable({
            // Options
            connectToSortable: binding.value.connectToSortable,
            cursor: binding.value.cursor || 'move',
            appendTo: binding.value.appendTo || 'body', // must not change due draggable + sortable bug
            containment: binding.value.containment || 'body',
            tolerance: binding.value.tolerance || 'pointer',
            revert: binding.value.revert || 'invalid',
            scroll: binding.value.scroll || false, // prevent scrolling out of screen
            helper: vnode.context[handlers.helper] || 'clone',
            // Events
            create: vnode.context[handlers.create] || noop,
            drag: vnode.context[handlers.drag]
                ? handleFixedDrag
                : fixedDrag,
            start: vnode.context[handlers.start]
                ? handleFixedStart
                : fixedStart,
            stop: vnode.context[handlers.stop] || noop,
        });
    },
});

/**
 * Turns an element droppable by using JQuery UI.
 * @see https://api.jqueryui.com/droppable/
 */
Vue.directive('drop', {
    inserted: function (element, binding, vnode) {

        const { handlers = {} } = binding.value;

        $(element).droppable({
            // Options
            activeClass: binding.value.activeClass,
            hoverClass: binding.value.hoverClass,
            // Events
            over: vnode.context[handlers.over] || noop,
            out: vnode.context[handlers.out] || noop,
            drop: vnode.context[handlers.drop] || noop,
        });
    },
});

/**
 * Turns the children of an element sortable by using JQuery UI.
 * @see https://api.jqueryui.com/sortable/
 */
Vue.directive('sortable', {
    inserted(element, binding, vnode) {

        const { handlers = {} } = binding.value;

        $(element).sortable({
            // Options
            connectWith: binding.value.connectWith || undefined,
            handle: binding.value.handle || undefined,
            items: binding.value.items || undefined,
            cursor: binding.value.cursor || 'move',
            cursorAt: binding.value.cursorAt || { top: 25, left: 25 },
            tolerance: binding.value.tolerance || 'pointer',
            containment: binding.value.containment || undefined,
            appendTo: binding.value.appendTo || undefined,
            scroll: binding.value.scroll || true,
            scrollSensitivity: binding.value.scrollSensitivity || 20,
            scrollSpeed: binding.value.scrollSpeed || 20,
            zIndex: 9999,
            opacity: binding.value.opacity || false,
            placeholder: binding.value.placeholder || {
                element() {
                    return $(
                        `<div class="draggable-line">
                            <span class="draggable-left-dot"></span>
                            <span class="draggable-right-dot"></span>
                        </div>`,
                    )[0];
                },
                update: noop,
            },
            helper: vnode.context[handlers.helper] || 'clone',
            // Events
            activate: vnode.context[handlers.activate] || noop,
            beforeStop: vnode.context[handlers.beforeStop] || noop,
            change: vnode.context[handlers.change] || noop,
            create: vnode.context[handlers.create] || noop,
            deactivate: vnode.context[handlers.deactivate] || noop,
            out: vnode.context[handlers.out] || noop,
            over: vnode.context[handlers.over] || noop,
            receive: vnode.context[handlers.receive] || noop,
            remove: vnode.context[handlers.remove] || noop,
            sort: vnode.context[handlers.sort] || noop,
            start: vnode.context[handlers.start] || noop,
            stop: vnode.context[handlers.stop] || noop,
            update: vnode.context[handlers.update] || noop,
        });
    },
});
